const colors = {
  main: {
    primary: '#DB1A1A',
    accent: '#828282',
    secondary: '#007A68',
    light: '#E1EFEC',
    dark: '#A31717',
    shallow: '#FDE9E9',
    error: '#EA2C2E',
    overlay: 'rgba(0, 0, 0, 0.45)',
    font: '#1E1E1E',
    background: '#F2F2F2',
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.15)'
  },
  appStatuses: {
    new: {
      text: '#344EAB',
      background: '#E6E3FF'
    },
    pending: {
      text: '#7C5F35',
      background: '#FFF4BD'
    },
    approved: {
      text: '#2D6528',
      background: '#C3E8C0'
    },
    rejected: {
      text: '#B10000',
      background: '#FDE9E9'
    },
    cancelled: {
      text: '#AB011F',
      background: '#FDE9F7'
    },
    signed: {
      text: '#245B5E',
      background: '#C0E6E8'
    },
    converted: {
      text: '#743E00',
      background: '#FED5A6'
    }
  },
  fundingStatuses: {
    requested: {
      text: '#C95501',
      background: '#FCF6ED'
    },
    scheduled: {
      text: '#4A82B5',
      background: '#E5EFF6'
    },
    done: {
      text: '#007A68',
      background: '#ECFDF9'
    }
  },
  loanStatuses: {
    pending: {
      background: '#B9740D'
    },
    approved: {
      background: '#54A786'
    },
    rejected: {
      background: '#A40606'
    },
    cancelled: {
      background: '#720619'
    },
    activeGood: {
      background: '#379088'
    },
    activeBad: {
      background: '#807943'
    },
    closedGood: {
      background: '#3B6C29'
    },
    closedBad: {
      background: '#C2245D'
    },
    rescheduled: {
      background: '#C95501'
    },
    closed: {
      background: '#EA2C2E'
    }
  },
  generalStatuses: {
    active: {
      text: '#ffffff',
      background: '#00C072'
    },
    inactive: {
      text: '#595959',
      background: '#E6E6E6'
    }
  },
  white: '#FFFFFF',
  darkGrey: '#595959',
  warmGrey: '#E6E6E6',
  lightWhiteSmoke: '#F6F6F6',
  green: '#00C072',
  darkGreen: '#099c60',
  darkRed: '#b12021',

  tooltip: {
    text: '#1E1E1E',
    background: '#FDE9E9',
    border: '#FDE9E9',
    boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.25)'
  }
};

export { colors };
